import React from 'react';
import { Button } from 'primereact/button';

import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';

function UploadFileButton() {
  const { modals, setSelectedItem, setVersionFileUpload } = useFileManagerContext();

  const handleUploadFile = () => {
    setSelectedItem();
    setVersionFileUpload(false);
    modals.setShowFileUploadModal(true);
  };

  return (
    <span className="disabled-button">
      <Button label="Upload" className="p-button  p-button-primary outline" onClick={handleUploadFile} />
    </span>
  );
}

export default UploadFileButton;
